import { useEffect } from "react"

import MultiConditionEditor, {
  ConditionFieldStateWithOperator,
} from "../../MultiConditionEditor"
import { getEditorData } from "../../utils"
import EditorDrawer, { useEditorDrawerState } from "../EditorDrawer"

export default function EntryConditionEditor({ open, onClose, node }) {
  const {
    newFieldState: newConditionFieldsState,
    setNewFieldState: setNewConditionFieldsState,
    tileChanged,
    saveState,
    revertState,
  } = useEditorDrawerState(ConditionFieldStateWithOperator.getDefaultState())

  useEffect(
    () => {
      const editorData = getEditorData(node)
      if (editorData) {
        setNewConditionFieldsState(getEditorData(node), false)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [node]
  )

  return (
    <EditorDrawer
      open={open}
      onClose={onClose}
      node={node}
      editorState={newConditionFieldsState}
      tileChanged={tileChanged}
      onChangesSaved={saveState}
      onChangesDiscarded={revertState}
      title="Entry Condition"
    >
      <MultiConditionEditor
        conditionFieldsState={newConditionFieldsState}
        setConditionFieldsState={setNewConditionFieldsState}
        addConditionButtonTitle="Add additional entry condition"
      />
    </EditorDrawer>
  )
}
